(() => {
  const SECTION_SELECTOR = '.shopify-section.collection__title';
  const ACTIVE_BODY_CLASS = 'collection-title--active';
  const HEADER_BG_CLASS = 'collection-title--header-bg';
  const SECTION_BG_CLASS = 'collection-title--section-bg';
  const SECTION_HIDDEN_CLASS = 'collection-title--section-hidden';
  const BG_DELAY = 800;

  document.addEventListener('DOMContentLoaded', () => {
    const sectionEl = document.querySelector(SECTION_SELECTOR);
    const headerEl = document.querySelector('.wt-header');
    if (!sectionEl || !headerEl) return;
    new CollectionTitleController(sectionEl, headerEl);
  });

  class CollectionTitleController {
    constructor(section, header) {
      this.section = section;
      this.header = header;
      this.root = document.documentElement;
      this.prevScrollY = window.pageYOffset;
      this.lastKnownScrollY = this.prevScrollY;
      this.direction = null;
      this.ticking = false;
      this.bgTimer = null;
      this.state = { headerBg: false, sectionBg: false, sectionHidden: false };

      this.handleScroll = this.handleScroll.bind(this);
      this.onAnimationFrame = this.onAnimationFrame.bind(this);
      this.updateOffsets = this.updateOffsets.bind(this);

      document.body.classList.add(ACTIVE_BODY_CLASS);
      this._applyState({ headerBg: false, sectionBg: false, sectionHidden: false });

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.updateOffsets();
      window.addEventListener('resize', this.updateOffsets);

      if (window.ResizeObserver) {
        new ResizeObserver(this.updateOffsets).observe(this.header);
      }
    }

    handleScroll() {
      this.lastKnownScrollY = window.pageYOffset;
      if (!this.ticking) {
        requestAnimationFrame(this.onAnimationFrame);
        this.ticking = true;
      }
    }

    onAnimationFrame() {
      this.ticking = false;
      const y = this.lastKnownScrollY;
      const delta = y - this.prevScrollY;

      if (Math.abs(delta) < 1) return;

      const dir = delta > 0 ? 'down' : 'up';

      if (dir !== this.direction) {
        this.direction = dir;
        if (dir === 'down') {
          this._onDown();
        } else {
          this._onUp();
        }
      }

      if (y <= 2) {
        this._cancelBgTimer();
        this._applyState({ headerBg: false, sectionBg: false, sectionHidden: false });
        this.direction = null;
      }

      this.prevScrollY = y;
    }

    _onDown() {
      this._cancelBgTimer();
      this._applyState({ headerBg: false, sectionBg: false, sectionHidden: true });
    }

    _onUp() {
      this._cancelBgTimer();
      this._applyState({ headerBg: false, sectionBg: false, sectionHidden: false });
      this.bgTimer = setTimeout(() => {
        this._applyState({ headerBg: true, sectionBg: true, sectionHidden: false });
      }, BG_DELAY);
    }

    _cancelBgTimer() {
      clearTimeout(this.bgTimer);
      this.bgTimer = null;
    }

    updateOffsets() {
      const h = parseFloat(getComputedStyle(this.root).getPropertyValue('--header-height')) || this.header?.getBoundingClientRect().height || 0;
      this.root.style.setProperty('--collection-title-offset', `${Math.round(h)}px`);
    }

    _applyState(next) {
      if (
        next.headerBg === this.state.headerBg &&
        next.sectionBg === this.state.sectionBg &&
        next.sectionHidden === this.state.sectionHidden
      ) return;

      this.state = { ...next };
      document.body.classList.toggle(HEADER_BG_CLASS, next.headerBg);
      document.body.classList.toggle(SECTION_BG_CLASS, next.sectionBg);
      document.body.classList.toggle(SECTION_HIDDEN_CLASS, next.sectionHidden);
    }
  }
})();
